<template>
  <div>
    <h1>留言板</h1>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>

</style>